/* JL · Product page behaviour: variant selection, gallery, add to cart, sticky bar, wishlist */
(function () {
  if (window.customElements.get('jl-product')) return;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var value = (cents / 100);
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var parts = value.toFixed(key.indexOf('no_decimals') > -1 ? 0 : 2).split('.');
      var sep = key.indexOf('comma_separator') > -1 ? ['.', ','] : [',', '.'];
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]);
      return parts.join(sep[1]);
    });
  }

  class JlProduct extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-jl-product-json]');
      if (!json) return;
      try { this.product = JSON.parse(json.textContent); } catch (e) { return; }
      this.moneyFormat = this.dataset.moneyFormat;
      this.form = document.getElementById(this.dataset.formId);
      this.idInput = this.form ? this.form.querySelector('[data-jl-variant-id]') : null;
      this.gallery = this.querySelector('[data-jl-gallery]');

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-jl-opt], [data-jl-opt-select]')) this.onOptionChange(e.target);
      });
      this.addEventListener('click', (e) => {
        var q = e.target.closest('[data-jl-qty]');
        if (q) {
          var input = q.parentElement.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.jlQty, 10));
        }
        var t = e.target.closest('[data-index]');
        if (t && (t.classList.contains('jl-pp__thumb') || t.classList.contains('jl-pp__dot'))) this.scrollToIndex(+t.dataset.index);
        if (e.target.closest('[data-jl-sticky-atc]')) {
          if (this.form && this.form.requestSubmit) this.form.requestSubmit(); else if (this.form) this.form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
        var w = e.target.closest('[data-jl-wish]');
        if (w) this.toggleWish(w);
      });
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.initGallery();
      this.initSticky();
      this.initWish();
      var current = this.currentVariant();
      if (current) this.updateAvailability(current), this.updateInventory(current);
    }

    selectedOptions() {
      var out = [];
      this.querySelectorAll('.jl-pp__opt[data-option-index]').forEach((fs) => {
        var i = +fs.dataset.optionIndex;
        var sel = fs.querySelector('[data-jl-opt-select]');
        var checked = fs.querySelector('[data-jl-opt]:checked');
        out[i] = sel ? sel.value : (checked ? checked.value : null);
      });
      return out;
    }

    currentVariant() {
      var opts = this.selectedOptions();
      if (!opts.length) return this.product.variants.find((v) => this.idInput && v.id == this.idInput.value) || this.product.variants[0];
      return this.product.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));
    }

    onOptionChange(el) {
      var fs = el.closest('.jl-pp__opt');
      if (fs) {
        var label = fs.querySelector('[data-jl-opt-value]');
        if (label) label.textContent = el.value;
        fs.querySelectorAll('.jl-pp__size, .jl-pp__swatch').forEach((l) => {
          var r = l.querySelector('input');
          l.classList.toggle('is-selected', !!(r && r.checked));
        });
      }
      if (this.colorGroups) this.filterColor(this.selectedOptions()[this.colorIndex]);
      var v = this.currentVariant();
      this.updateAvailability(v);
      if (!v) { this.setAtc(false, 'Unavailable'); return; }
      if (this.idInput) {
        this.idInput.value = v.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.updatePrice(v);
      this.updateInventory(v);
      this.setAtc(v.available, v.available ? 'Add to cart' : 'Sold out');
      this.querySelectorAll('[data-jl-sku]').forEach((n) => (n.textContent = v.sku ? 'SKU: ' + v.sku : ''));
      if (v.media) this.showMedia(v.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('jl:variant:change', { detail: { variant: v, product: this.product } }));
    }

    updatePrice(v) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      this.querySelectorAll('[data-jl-price]').forEach((n) => (n.textContent = formatMoney(v.price, this.moneyFormat)));
      this.querySelectorAll('[data-jl-compare]').forEach((n) => {
        n.hidden = !onSale;
        if (onSale) n.textContent = formatMoney(v.compare_at_price, this.moneyFormat);
      });
      this.querySelectorAll('[data-jl-save]').forEach((n) => {
        n.hidden = !onSale;
        var amt = n.querySelector('[data-jl-save-amount]');
        if (onSale && amt) amt.textContent = formatMoney(v.compare_at_price - v.price, this.moneyFormat);
      });
      this.querySelectorAll('[data-jl-sale-badge]').forEach((n) => (n.hidden = !onSale));
      this.querySelectorAll('[data-jl-soldout-badge]').forEach((n) => (n.hidden = v.available));
    }

    updateInventory(v) {
      this.querySelectorAll('[data-jl-inventory]').forEach((n) => {
        var t = +n.dataset.threshold || 0;
        if (!v || !v.available) n.textContent = '';
        else if (v.inventory != null && t > 0 && v.inventory <= t) n.textContent = 'Only ' + v.inventory + ' left in stock';
        else n.textContent = 'In stock, ready to ship';
      });
    }

    /* grey out option values that have no available variant given the other selections */
    updateAvailability() {
      var opts = this.selectedOptions();
      this.querySelectorAll('.jl-pp__opt[data-option-index]').forEach((fs) => {
        var i = +fs.dataset.optionIndex;
        fs.querySelectorAll('.jl-pp__size').forEach((label) => {
          var input = label.querySelector('input');
          if (!input) return;
          var ok = this.product.variants.some((v) => v.available && v.options[i] === input.value && v.options.every((o, j) => j === i || opts[j] == null || o === opts[j]));
          label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    setAtc(enabled, text) {
      this.querySelectorAll('[data-jl-atc], [data-jl-sticky-atc]').forEach((b) => {
        b.disabled = !enabled;
        var l = b.querySelector('[data-jl-atc-label]');
        if (l) l.textContent = text;
      });
    }

    async onSubmit(e) {
      e.preventDefault();
      var btn = this.form.querySelector('[data-jl-atc]');
      var err = this.form.querySelector('[data-jl-error]');
      if (!this.form.reportValidity || this.form.reportValidity()) {} else return;
      if (btn && btn.disabled) return;
      var fd = new FormData(this.form);
      document.querySelectorAll('[form="' + this.form.id + '"]').forEach((el) => {
        if (el.name && !(el.type === 'checkbox' && !el.checked)) fd.set(el.name, el.value);
      });
      var variantId = Number(fd.get('id'));
      if (btn) btn.classList.add('is-loading');
      if (err) err.hidden = true;
      try {
        var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        this.form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: variantId, cart: data } }));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    }

    /* gallery */
    initGallery() {
      if (!this.gallery) return;
      this.slides = Array.prototype.slice.call(this.gallery.children);
      // only show the photos of the selected colour
      this.initColorGroups();
      if (this.colorGroups) this.filterColor(this.selectedOptions()[this.colorIndex]);
      // like Jolisina: the selected variant's image first
      var featured = this.gallery.querySelector('.is-featured');
      if (featured && featured !== this.slides[0]) this.showMedia(featured.dataset.mediaId, true);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > .6) this.setActive(+en.target.dataset.index); });
        }, { root: this.gallery, threshold: [.6] });
        this.slides.forEach((s) => io.observe(s));
      }
    }

    /* colour groups: each colour owns the photos from its variant photo up to the next colour's first photo */
    initColorGroups() {
      this.colorGroups = null;
      var fs = this.querySelector('.jl-pp__opt--color[data-option-index]');
      if (!fs || !this.slides || this.slides.length < 2) return;
      var ci = +fs.dataset.optionIndex;
      var pos = {};
      this.slides.forEach((s) => { pos[s.dataset.mediaId] = +s.dataset.index; });
      var starts = [], seen = {};
      this.product.variants.forEach((v) => {
        var c = v.options[ci];
        if (c == null || seen[c] || v.media == null || pos[v.media] == null) return;
        seen[c] = true;
        starts.push({ color: c, start: pos[v.media] });
      });
      if (starts.length < 2) return;
      starts.sort((a, b) => a.start - b.start);
      var total = this.slides.length, groups = {};
      starts.forEach((g, i) => {
        var from = i === 0 ? 0 : g.start;
        var to = i + 1 < starts.length ? starts[i + 1].start - 1 : total - 1;
        if (to < from) to = from;
        groups[g.color] = { from: from, to: to };
      });
      this.colorIndex = ci;
      this.colorGroups = groups;
    }

    filterColor(color) {
      if (!this.colorGroups || !this.slides) return;
      var g = this.colorGroups[color];
      var inGroup = (i) => !g || (i >= g.from && i <= g.to);
      this.slides.forEach((s) => { s.hidden = !inGroup(+s.dataset.index); });
      this.querySelectorAll('.jl-pp__thumb, .jl-pp__dot').forEach((b) => { b.hidden = !inGroup(+b.dataset.index); });
      if (g) {
        if (this.isCarousel() && this.gallery) this.gallery.scrollLeft = 0;
        this.setActive(g.from);
        var thumbs = this.querySelector('.jl-pp__thumbs');
        if (thumbs) thumbs.scrollLeft = 0;
      }
    }

    isCarousel() { return window.matchMedia('(max-width: 999px)').matches; }

    showMedia(mediaId, initial) {
      var slide = this.gallery && this.gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (!slide) return;
      if (this.isCarousel()) {
        if (!initial) this.scrollToIndex(+slide.dataset.index);
        else this.gallery.scrollLeft = slide.offsetLeft - this.gallery.offsetLeft;
      } else if (slide !== this.gallery.firstElementChild) {
        this.gallery.prepend(slide);
        if (!initial) {
          var top = this.gallery.getBoundingClientRect().top;
          if (top < 0) window.scrollTo({ top: window.scrollY + top - 100, behavior: 'smooth' });
        }
      }
    }

    scrollToIndex(i) {
      var slide = this.gallery && this.gallery.querySelector('[data-index="' + i + '"]');
      if (!slide) return;
      this.gallery.scrollTo({ left: slide.offsetLeft - this.gallery.offsetLeft, behavior: 'smooth' });
      this.setActive(i);
    }

    setActive(i) {
      this.querySelectorAll('.jl-pp__thumb, .jl-pp__dot').forEach((b) => b.classList.toggle('is-active', +b.dataset.index === i));
      var active = this.querySelector('.jl-pp__thumb.is-active');
      if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
        active.parentElement.scrollTo({ left: active.offsetLeft - 40, behavior: 'smooth' });
      }
    }

    /* sticky add to cart */
    initSticky() {
      var bar = this.querySelector('[data-jl-sticky]');
      var atc = this.querySelector('[data-jl-atc]');
      if (!bar || !atc || !('IntersectionObserver' in window)) return;
      var immediate = this.dataset.stickyImmediate === 'true';
      var io = new IntersectionObserver((entries) => {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        var show = immediate ? !e.isIntersecting : past;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(atc);
      this.querySelectorAll('[data-jl-sticky] [data-jl-price]').forEach(() => {});
    }

    /* wishlist (local only) */
    wishList() { try { return JSON.parse(localStorage.getItem('jl_wishlist') || '[]'); } catch (e) { return []; } }
    initWish() {
      var list = this.wishList();
      this.querySelectorAll('[data-jl-wish]').forEach((b) => b.setAttribute('aria-pressed', list.indexOf(b.dataset.jlWish) > -1 ? 'true' : 'false'));
    }
    toggleWish(b) {
      var list = this.wishList(), h = b.dataset.jlWish, i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      try { localStorage.setItem('jl_wishlist', JSON.stringify(list.slice(0, 100))); } catch (e) {}
      b.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
    }
  }

  window.customElements.define('jl-product', JlProduct);
})();
